import { render, staticRenderFns } from "./PushNotificationsDialog.vue?vue&type=template&id=4621b864"
import script from "./PushNotificationsDialog.vue?vue&type=script&lang=js"
export * from "./PushNotificationsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports